var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 90,
    viewBox: "0 0 92 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_23_156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M56.2156 43.3151L47.1378 51.9802L8.80341 88.5661C7.79702 89.5289 6.506 90.0103 5.21497 90.0103C3.80196 90.0103 2.38894 89.4367 1.36222 88.2998C-0.660727 86.0669 -0.396422 82.5743 1.93149 80.6692L47.1378 43.8272L52.1189 39.7712L56.2156 43.3151Z",
    fill: "url(#paint0_linear_23_156)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M46.7413 52.4206L37.8058 60.9423L36.9824 52.185L41.872 48.2007L46.7413 52.4206Z",
    fill: "#3A81D6",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M91.978 29.9078C91.978 46.4288 78.6815 59.8259 62.2946 59.8259C51.9664 59.8259 42.8682 54.5101 37.5516 46.4391C34.4308 41.7071 32.6111 36.0225 32.6111 29.9078C32.6111 13.3868 45.9077 0 62.2946 0C69.6951 0 76.4552 2.72448 81.6498 7.23114C87.9728 12.7211 91.978 20.8433 91.978 29.9078Z",
    fill: "url(#paint1_linear_23_156)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M62.2946 53.2093C75.0671 53.2093 85.4213 42.7768 85.4213 29.9078C85.4213 17.0387 75.0671 6.60632 62.2946 6.60632C49.5221 6.60632 39.1679 17.0387 39.1679 29.9078C39.1679 42.7768 49.5221 53.2093 62.2946 53.2093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.06,
    d: "M91.978 29.9078C91.978 46.4288 78.6815 59.8259 62.2946 59.8259C51.9664 59.8259 42.8682 54.5101 37.5516 46.4391C71.0268 43.6941 79.8505 15.1178 81.66 7.23114C87.9728 12.7211 91.978 20.8433 91.978 29.9078Z",
    fill: "#1A6FB5",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M62.2946 29.959C64.9783 29.959 67.1537 27.7672 67.1537 25.0632C67.1537 22.3592 64.9783 20.1673 62.2946 20.1673C59.6109 20.1673 57.4354 22.3592 57.4354 25.0632C57.4354 27.7672 59.6007 29.959 62.2946 29.959ZM62.2946 32.407C59.0518 32.407 52.5763 34.0458 52.5763 37.3028V38.5319C52.5763 39.2079 53.1252 39.761 53.7962 39.761H70.8133C71.4842 39.761 72.0332 39.2079 72.0332 38.5319V37.3028C72.0128 34.056 65.5374 32.407 62.2946 32.407Z",
    fill: "url(#paint2_linear_23_156)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23_156",
    x1: 5.67475,
    y1: 84.3265,
    x2: 53.9244,
    y2: 40.7922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67C3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A98F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23_156",
    x1: 50.0173,
    y1: 2.11336,
    x2: 72.7818,
    y2: 52.9053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67C3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A98F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_23_156",
    x1: 55.2686,
    y1: 28.3947,
    x2: 72.9196,
    y2: 36.9391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071077,
    stopColor: "#A6F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2937,
    stopColor: "#8BE8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5209,
    stopColor: "#78E1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7536,
    stopColor: "#6DDDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69DCFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.978,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9b8b0387b1340388f8e72bde0ab42f34.svg";
export { ForwardRef as ReactComponent };